<template>
  <div class="d-flex flex-column vh-100">
    <div class="flex-shrink-0">
      <CandlesToolbar :crosshairOn="toolbar.crosshairOn" :infoOn="toolbar.infoOn" :tfLabel="toolbar.tfLabel"
        :chartTypeLabel="toolbar.chartTypeLabel" :tableOn="toolbar.tableOn" @toggle-crosshair="onToggleCrosshair"
        @toggle-info="onToggleInfo" @toggle-table="onToggleTable" @open-menu="onOpenMenu" @popout="onPopout"
        :drawOn="toolbar.drawOn" @toggle-draw="onToggleDraw" />
    </div>
    <div class="flex-grow-1 overflow-hidden">
      <div class="container-fluid h-100 px-0">
        <div class="h-100 d-flex flex-column flex-md-row">
          <div v-if="!isPopout" class="col-12 col-md-5 col-lg-4 px-0 border-bottom border-right overflow-auto">
            <Watchlist @open-chart="onOpenChartFromWatchlist" />
          </div>
          <div class="flex-grow-1 h-100 overflow-hidden px-0">
            <div v-show="toolbar.tableOn" class="h-100">
              <CandlesTable :title="selectedSymbol" :rows="tableRows" :columns="tableColumns" @close="closeTable" />
            </div>
            <div v-show="!toolbar.tableOn" class="h-100">
              <CandlesChart ref="chartRef" @toolbar-state="toolbar = { ...toolbar, ...$event }"
                @candles="tableRows = $event" @table-columns="onTableColumns"
                @studies-change="activeStudies = $event" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CandlesToolbar from "./CandlesToolbar.vue";
import CandlesChart from "./CandlesChart.vue";
import CandlesTable from "./CandlesTable.vue";
import Watchlist from "./Watchlist.vue";
const storage_key = "chart:selectedSymbol";
export default {
  name: "CandlesHardcoded",
  components: { CandlesToolbar, CandlesChart, CandlesTable, Watchlist },
  data() {
    return {
      selectedSymbol: "SILVER",
      tableRows: [],
      tableColumns: [],
      activeStudies: [],
      toolbar: {
        crosshairOn: false,
        infoOn: false,
        tfLabel: "1D",
        chartTypeLabel: "Candles",
        tableOn: false,
        drawOn: false,
      },
    };
  },
  computed: {
    isPopout() {
      return this.$route.query.popout !== undefined;
    },
  },
  created() {
    if (this.isPopout) {
      const token = localStorage.getItem("accessToken");
      const expiresOn = localStorage.getItem("expiresOn");
      const key = localStorage.getItem(storage_key);
      if (token) sessionStorage.setItem("accessToken", token);
      if (expiresOn) sessionStorage.setItem("expiresOn", expiresOn);
      if (key) sessionStorage.setItem(storage_key, key);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("expiresOn");
      localStorage.removeItem(storage_key);
    }
    const stored = sessionStorage.getItem(storage_key);
    if (stored && String(stored).trim()) {
      this.selectedSymbol = String(stored).trim();
    } else {
      this.selectedSymbol = "SILVER";
      sessionStorage.setItem(storage_key, this.selectedSymbol);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.chartRef?.setSymbol?.(this.selectedSymbol);
    });
  },
  methods: {
    onToggleDraw() {
      if (this.toolbar.tableOn) return;
      this.toolbar.drawOn = !this.toolbar.drawOn;
      this.$refs.chartRef?.setDrawPanelOpen?.(this.toolbar.drawOn);
    },
    closeTable() {
      this.toolbar.tableOn = false;
      this.$nextTick(() => this.$refs.chartRef?.resize?.());
    },
    onTableColumns(col) {
      this.tableColumns = col;
    },
    onToggleCrosshair() {
      if (this.toolbar.tableOn) return;
      this.$refs.chartRef?.toggleCrosshair?.();
    },
    onToggleInfo() {
      if (this.toolbar.tableOn) return;
      this.$refs.chartRef?.toggleInfo?.();
    },
    onOpenMenu({ kind, anchorEl }) {
      if (this.toolbar.tableOn) return;
      this.$refs.chartRef?.openMenu?.(kind, anchorEl);
    },
    onToggleTable() {
      if (!this.toolbar.tableOn) {
        this.toolbar.drawOn = false;
        this.$refs.chartRef?.setDrawPanelOpen?.(false);
        this.$refs.chartRef?.emitVisibleTableNow?.();
        this.toolbar.tableOn = true;
        return;
      }
      this.toolbar.tableOn = false;
      this.$nextTick(() => this.$refs.chartRef?.resize?.());
    },
    onOpenChartFromWatchlist(payload) {
      const sym = payload?.tradingsymbol;
      if (!sym) return;
      const next = String(sym).trim();
      if (!next) return;
      this.selectedSymbol = next;
      sessionStorage.setItem(storage_key, next);
      this.$refs.chartRef?.setSymbol?.(next);
    },
    onPopout() {
      const key = sessionStorage.getItem(storage_key);
      if (key) localStorage.setItem(storage_key, key);
      const token = sessionStorage.getItem("accessToken");
      const expiresOn = sessionStorage.getItem("expiresOn");
      if (token) localStorage.setItem("accessToken", token);
      if (expiresOn) localStorage.setItem("expiresOn", expiresOn);
      const { popout, ...rest } = this.$route.query || {};
      const query = { ...rest, popout: 1 };
      const { href } = this.$router.resolve({ path: this.$route.path, query });
      window.open(href, "_blank", "noopener,noreferrer");
    },
  },
};
</script>
